import * as React from 'react'

import { Box, Checkbox } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: (value: number | null) => void
  onClick: () => void
  width?: string
  customFieldId: number
}

const CustomFieldNumber = ({
  bulkEditForm,
  onChange,
  onClick,
  isChecked,
  width,
  customFieldId,
}: Props) => {
  const field = bulkEditForm.get(customFieldId.toString())
  const [value, setValue] = React.useState<number | null>(
    field?.hasValue ? field?.value / 100 : null
  )

  // All of this cents management is a bit confusing, but it's because the
  // custom fields in the employee profile are stored in cents, so we need to
  // convert the value to cents when saving it.
  const onHandleBlur = () => {
    const valueInCents = value !== null ? Math.round(value * 100) : null

    bulkEditForm.setValues({
      [customFieldId]: valueInCents,
    })

    onChange(valueInCents)
  }

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <NumberField
        onChange={setValue}
        value={typeof value === 'number' ? value : undefined}
        onBlur={onHandleBlur}
      />
    </Box>
  )
}

export default CustomFieldNumber
